export function formatDateTime(iso, { showTimeZone = false, timeZone = null } = {}) {
  if (!iso) return '—';
  const tz = timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  const formatted = new Intl.DateTimeFormat('es-ES', {
    timeZone: tz,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  }).format(date);
  return showTimeZone ? `${formatted} (${tz})` : formatted;
}
